import React from 'react';
import {connect} from "react-redux";
import DocsAndImportantToKnow from "./DocsAndImportantToKnow";
import GeneralDetails from '../GeneralDetailsBlock/GeneralDetails';


const DocsAndImportantToKnowBlock = ({data, context, docsAndImportantToKnow, dealType, generalDetails}) => {

    return <DocsAndImportantToKnow data={data} context={context} docsAndImportantToKnow={docsAndImportantToKnow} dealType={dealType} generalDetails={generalDetails}  />
}


const mapStateToProps = (state) => {
    return {
      docsAndImportantToKnow: state.cellcomTransactionSummary.transactionData.docsAndImportantToKnow,
      dealType: state.cellcomTransactionSummary.transactionData.dealType,
      generalDetails:
      state.cellcomTransactionSummary.transactionData.generalDetails,
    };
  };


  export default connect(mapStateToProps, null)(DocsAndImportantToKnowBlock);
